<template>
  <div class="wishlist">
    <KaaliWishlist
      v-if="type === 'kaali'"
      :productId="productId"
      :regularPrice="regularPrice"
      :salePrice="salePrice"
      :quantity="quantity"
      :selectedPackage="selectedPackage"
      :inWishlist="isInWishlist"
    />
  </div>
</template>

<script>
import KaaliWishlist from '@/components/general-ui/wishlists/Kaali.vue';

export default {
  name: 'Wishlist',
  components: {
    KaaliWishlist,
  },
  props: {
    productId: {
      type: Number,
      required: true
    },
    selectedPackage: {
      type: String
    },
    regularPrice: {
      type: Number
    },
    salePrice: {
      type: Number
    },
    quantity: {
      type: Number
    }
  },
  data() {
    return {
      type: ws_vue_store.config['single-product-wishlist'],
    };
  },
  computed: {
    isInWishlist() {
      return this.$store.getters.isInActiveWishlist(this.productId);
    }
  }
};
</script>